var map = {
	"./CanvasClear": 42,
	"./CanvasClear.js": 42,
	"./CanvasMove": 43,
	"./CanvasMove.js": 43,
	"./CommandAbstract": 21,
	"./CommandAbstract.js": 21,
	"./ComponentDelete": 44,
	"./ComponentDelete.js": 44,
	"./ComponentDrag": 45,
	"./ComponentDrag.js": 45,
	"./ComponentEnter": 46,
	"./ComponentEnter.js": 46,
	"./ComponentExit": 47,
	"./ComponentExit.js": 47,
	"./ComponentNext": 48,
	"./ComponentNext.js": 48,
	"./ComponentPrev": 49,
	"./ComponentPrev.js": 49,
	"./ComponentStyleClear": 50,
	"./ComponentStyleClear.js": 50,
	"./CopyComponent": 51,
	"./CopyComponent.js": 51,
	"./DeleteComponent": 52,
	"./DeleteComponent.js": 52,
	"./ExportTemplate": 53,
	"./ExportTemplate.js": 53,
	"./Fullscreen": 54,
	"./Fullscreen.js": 54,
	"./MoveComponent": 55,
	"./MoveComponent.js": 55,
	"./OpenAssets": 56,
	"./OpenAssets.js": 56,
	"./OpenBlocks": 57,
	"./OpenBlocks.js": 57,
	"./OpenLayers": 58,
	"./OpenLayers.js": 58,
	"./OpenStyleManager": 59,
	"./OpenStyleManager.js": 59,
	"./OpenTraitManager": 60,
	"./OpenTraitManager.js": 60,
	"./PasteComponent": 61,
	"./PasteComponent.js": 61,
	"./Preview": 62,
	"./Preview.js": 62,
	"./Resize": 63,
	"./Resize.js": 63,
	"./SelectComponent": 13,
	"./SelectComponent.js": 13,
	"./SelectPosition": 25,
	"./SelectPosition.js": 25,
	"./ShowOffset": 64,
	"./ShowOffset.js": 64,
	"./SwitchVisibility": 65,
	"./SwitchVisibility.js": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89;